export const LIST_EXAMINATION_SUMMARY_REQUEST = 'LIST_EXAMINATION_SUMMARY_REQUEST'
export const LIST_EXAMINATION_SUMMARY_SUCCESS = 'LIST_EXAMINATION_SUMMARY_SUCCESS'
export const LIST_EXAMINATION_SUMMARY_FAIL = 'LIST_EXAMINATION_SUMMARY_FAIL'
export const LIST_EXAMINATION_SUMMARY_RESET = 'LIST_EXAMINATION_SUMMARY_RESET'

export const LIST_EXAMINATION_REQUEST = 'LIST_EXAMINATION_REQUEST'
export const LIST_EXAMINATION_SUCCESS = 'LIST_EXAMINATION_SUCCESS'
export const LIST_EXAMINATION_FAIL = 'LIST_EXAMINATION_FAIL'
export const LIST_EXAMINATION_RESET = 'LIST_EXAMINATION_RESET'

export const CREATE_EXAMINATION_REQUEST = 'CREATE_EXAMINATION_REQUEST'
export const CREATE_EXAMINATION_SUCCESS = 'CREATE_EXAMINATION_SUCCESS'
export const CREATE_EXAMINATION_FAIL = 'CREATE_EXAMINATION_FAIL'

export const DETAIL_EXAMINATION_REQUEST = 'DETAIL_EXAMINATION_REQUEST'
export const DETAIL_EXAMINATION_SUCCESS = 'DETAIL_EXAMINATION_SUCCESS'
export const DETAIL_EXAMINATION_FAIL = 'DETAIL_EXAMINATION_FAIL'

export const UPDATE_EXAMINATION_REQUEST = 'UPDATE_EXAMINATION_REQUEST'
export const UPDATE_EXAMINATION_SUCCESS = 'UPDATE_EXAMINATION_SUCCESS'
export const UPDATE_EXAMINATION_FAIL = 'UPDATE_EXAMINATION_FAIL'

export const DELETE_EXAMINATION_REQUEST = 'DELETE_EXAMINATION_REQUEST'
export const DELETE_EXAMINATION_SUCCESS = 'DELETE_EXAMINATION_SUCCESS'
export const DELETE_EXAMINATION_FAIL = 'DELETE_EXAMINATION_FAIL'

export const UPDATE_EXAMINATION_POSITION_REQUEST = 'UPDATE_EXAMINATION_POSITION_REQUEST'
export const UPDATE_EXAMINATION_POSITION_SUCCESS = 'UPDATE_EXAMINATION_POSITION_SUCCESS'
export const UPDATE_EXAMINATION_POSITION_FAIL = 'UPDATE_EXAMINATION_POSITION_FAIL'

